import React from 'react';
import styles from './MultiSendInfo.module.css';
import { BaseStyles, Flex, Box, Button, Heading, Text } from 'rimble-ui';
import { PAYMENT_OPTION, TOKEN_TYPE } from '../../constants';

function MultiSendInfo(props) {
  return (
    <BaseStyles>
      <Flex className={styles.tokenType}>
        <Box>
          <Heading as='h2'>Token Type: </Heading>
        </Box>
        <Box className={styles.btnGroup}>
          <Button
            size='small'
            mainColor='black'
            icon={props.tokenType === TOKEN_TYPE.ERC20 ? 'Check' : ''}
            iconpos='right'
            className={styles.tokenTypeBtn}
            onClick={() => {
              props.changeTokenType(TOKEN_TYPE.ERC20);
            }}
          >
            ERC20
          </Button>
          <Button
            size='small'
            mainColor='black'
            icon={props.tokenType === TOKEN_TYPE.ERC721 ? 'Check' : ''}
            iconpos='right'
            className={styles.tokenTypeBtn}
            onClick={() => {
              props.changeTokenType(TOKEN_TYPE.ERC721);
            }}
          >
            ERC721
          </Button>
          <Button
            size='small'
            mainColor='black'
            icon={props.tokenType === TOKEN_TYPE.ERC1155 ? 'Check' : ''}
            iconpos='right'
            className={styles.tokenTypeBtn}
            onClick={() => {
              props.changeTokenType(TOKEN_TYPE.ERC1155);
            }}
          >
            ERC1155
          </Button>
        </Box>
      </Flex>
      <Flex className={styles.paymentOption}>
        <Box>
          <Heading as='h2'>Payment Option: </Heading>
        </Box>
        <Box className={styles.btnGroup}>
          <Button
            size='small'
            mainColor='black'
            icon={props.paymentOption === PAYMENT_OPTION.ETH ? 'Check' : ''}
            iconpos='right'
            className={styles.tokenTypeBtn}
            onClick={() => {
              props.changePaymentOption(PAYMENT_OPTION.ETH);
            }}
          >
            ETH
          </Button>
          <Button
            size='small'
            mainColor='black'
            icon={props.paymentOption === PAYMENT_OPTION.ZUT ? 'Check' : ''}
            iconpos='right'
            className={styles.tokenTypeBtn}
            onClick={() => {
              props.changePaymentOption(PAYMENT_OPTION.ZUT);
            }}
          >
            ZUT
          </Button>
        </Box>
      </Flex>
      <Flex className={styles.paymentOption}>
        <Box>
          <Heading as='h4'>
            You have: {props.accountEthAmount} ETH and {props.accountZutAmount}{' '}
            ZUT
          </Heading>
          <Heading as='h4'>
            Fees per use: {props.feesEth} ETH or {props.feesZut} ZUT
          </Heading>
        </Box>
      </Flex>
    </BaseStyles>
  );
}

export default MultiSendInfo;
